module.exports = __webpack_public_path__ + "static/media/blue-logo-main.524182b3.svg";